import { lazy } from 'react';
import { isChunkLoadError, reloadOnceForStaleChunk } from './chunkLoadError';

const importWithChunkReload = (componentImport) =>
	componentImport().catch((error) => {
		if (isChunkLoadError(error) && reloadOnceForStaleChunk()) {
			return new Promise(() => {});
		}
		throw error;
	});

export const lazyWithRetry = (componentImport) => lazy(() => importWithChunkReload(componentImport));
